// reducer.js
import * as constants from './constants';

const INITIAL_STATE = {
  metadata: {
    title: 'Auto 2000',
    description: '',
    keywords: '',
    author: '',
    ogImage: '',
    ogUrl: '',
    twitterCard: '',
    twitterSite: '',
    currentURL: '',
    richTextContent: '',
    faqStructuredData: null,
    reviewStructuredData: null,
    robots: '',
    breadcrumbItems: null,
    // Add other state properties if needed
  },
};

const metadataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_METADATA:
      return { ...state, metadata: { ...state.metadata, ...action.payload } };
    default:
      return state;
  }
};

export default metadataReducer;
